import React, { useState, useRef } from 'react';
import AnnouncementBar from './AnnouncementBar';
import Header from './Header';

const TopExperienceLayer = () => {
  const [_announcementHeight, setAnnouncementHeight] = useState(40);
  const [showAnnouncement, setShowAnnouncement] = useState(true);
  const containerRef = useRef(null);

  const handleAnnouncementDismiss = () => {
    setShowAnnouncement(false);
    setAnnouncementHeight(0);
  };

  const topOffset = showAnnouncement ? 40 + 64 : 64;

  return (
    <>
      {/* Fixed Top Layer Container */}
      <div
        ref={containerRef}
        className="fixed top-0 left-0 right-0"
        style={{ zIndex: 60 }}
      >
        {/* Announcement Bar */}
        {showAnnouncement && (
          <div style={{ zIndex: 60 }}>
            <AnnouncementBar onDismiss={handleAnnouncementDismiss} />
          </div>
        )}

        {/* Header */}
        <div style={{ zIndex: 50 }}>
          <Header announcementVisible={showAnnouncement} />
        </div>
      </div>

      {/* Spacer to prevent content from going under fixed header */}
      <div style={{ height: `${topOffset}px` }} />
    </>
  );
};

export default TopExperienceLayer;
